import { FC, Suspense } from 'react';
import { twMerge } from 'tailwind-merge';

import { Skeleton } from '../Skeleton';
import { getSize, getSkeletonClassName } from './Icon.styles';
import type { IconProps } from './Icon.types';

export const Icon: FC<IconProps> = ({ source: SourceComponent, size = 'medium', color, className, ...rest }) => {
	const colorClassName = color ? className : twMerge('text-gray-700', className);

	return (
		<Suspense fallback={<Skeleton className={twMerge('shrink-0', getSkeletonClassName(size))} />}>
			<SourceComponent
				{...(color ? { color } : {})}
				focusable={false}
				className={twMerge('shrink-0', colorClassName)}
				{...getSize(size)}
				{...rest}
			/>
		</Suspense>
	);
};
